import React from 'react';
import './Style/PrivacyPolicy.css';
import TopNavbar from './../home/TopNavbar';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <TopNavbar name="Privacy Policy" />
      <div className="privacy-card">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-updated">Last Updated: October 2026</p>

        <section className="privacy-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to JEE Mock Test. We value your privacy and are committed to providing a secure environment for your Joint Entrance Examination preparation (JEE Main and JEE Advanced). This Privacy Policy outlines how we collect, use, and protect your personal information when you create an account and use our app.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Information We Collect</h2>
          <p>
            When you register an account in JEE Mock Test, we collect personal information required to authenticate your account and personalize your study experience:
          </p>
          <ul>
            <li><strong>Full Name:</strong> To personalize your user profile and test score reports.</li>
            <li><strong>Class/Grade:</strong> To customize mock test material suited to your target year.</li>
            <li><strong>Phone Number:</strong> For account identity and security.</li>
            <li><strong>Email Address:</strong> Used as your unique account ID and for OTP verification.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. How We Use and Store Your Data</h2>
          <p>
            Your profile details, mock test scores, subject performance metrics (Physics, Chemistry, and Mathematics), and account credentials are stored securely on our database servers.
          </p>
          <p>
            This data is strictly used to sync your test progress across sessions, verify login authentication via OTP, and present performance analytics. We do not sell, rent, or trade your personal data to third parties.
          </p>
        </section>

        <section className="privacy-section">
          <h2>4. Account Deletion and Data Rights</h2>
          <p>
            In accordance with Google Play Developer Policies, you retain full control over your personal data:
          </p>
          <ul>
            <li>
              <strong>In-App Account Deletion:</strong> You can request immediate deletion of your account and associated data directly within the app under <em>Profile &gt; Settings &gt; Delete Account</em>.
            </li>
            <li>
              <strong>Web Account Deletion Request:</strong> If you cannot access the app, you may request account and data removal by sending an email with your registered email/phone number to <a href="mailto:contact@mystudyplace.online">contact@mystudyplace.online</a> with the subject "Account Deletion Request".
            </li>
          </ul>
          <p>
            Upon receiving your request, all personal data, profile information, and test history will be permanently deleted from our primary servers.
          </p>
        </section>

        <section className="privacy-section">
          <h2>5. Data Sharing and Third-Party Access</h2>
          <p>
            <strong>We do not sell, trade, rent, or share your personal information with third parties.</strong>
          </p>
          <p>
            Your account details (Full Name, Class, Phone Number, and Email Address) and test performance history are strictly used to operate the JEE Mock Test application and provide account authentication. We do not transmit your data to third-party advertising networks, data brokers, or external analytics providers.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Government Entity & Official Exam Disclaimer</h2>
          <p>
            JEE Mock Test is an independent educational platform and is not affiliated with, endorsed by, or connected to the National Testing Agency (NTA), IITs, or any official government examination authority.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. Changes to This Policy</h2>
          <p>
            We may update our Privacy Policy periodically. Any updates will be reflected here with a revised "Last Updated" date.
          </p>
        </section>

        <section className="privacy-section contact-section">
          <h2>8. Contact Us</h2>
          <p>If you have any questions or data deletion requests regarding this Privacy Policy, please contact us at:</p>
          <div className="contact-details">
            <p><strong>Email:</strong> <a href="mailto:contact@mystudyplace.online">contact@mystudyplace.online</a></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;